module.exports = __webpack_public_path__ + "img/Chef_ZahieTellez.fdb8a411.jpg";